import { createRequest } from "helpers/tools";

export const pipedriveMappings = async (data, id) => {
    return await createRequest({
        suffix: `sources/pipe/update/${id}`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const sendDataPipedrive = async (data) => {
    return await createRequest({
        suffix: "sources/pipe/store",
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const getPipedriveUrl = async () => {
    return await createRequest({
        suffix: `sources/pipe/auth-url`,
        handleError: true,
        method: "get",
    });
};

export const updatePipedriveSource = async (id) => {
    return await createRequest({
        suffix: `sources/pipe/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getPipedriveTrackerEvent = async (sourceId) => {
    return await createRequest({
        suffix: `sources/pipe/${sourceId}/preview`,
        method: "get",
        handleError: false,
    });
};

export const pipedriveReconnect = async (id, data) => {
    return await createRequest({
        suffix: `sources/${id}/service-update`,
        method: "post",
        payload: data,
        handleError: false,
    });
};
